import {
  Chat,
  DocumentBlank,
  DocumentPdf,
  DocumentWordProcessor,
  Paste,
  Txt,
} from "@carbon/react/icons";
import { fileTypeLabel } from "@/lib/ui/format";

const FILE_TYPE_ICONS = {
  PDF: DocumentPdf,
  DOCX: DocumentWordProcessor,
  TXT: Txt,
  MD: DocumentBlank,
  Заметка: Paste,
  Мессенджер: Chat,
  Файл: DocumentBlank,
} as const;

type FileTypeKey = keyof typeof FILE_TYPE_ICONS;

function fileTypeKind(label: string): string {
  if (label === "Заметка") {
    return "note";
  }
  if (label === "Мессенджер") {
    return "messenger";
  }
  if (label === "Файл") {
    return "file";
  }
  return label.toLowerCase();
}

export function FileTypeIcon({
  type,
  mimeType,
  fileName,
}: {
  type?: string;
  mimeType?: string | null;
  fileName?: string;
}) {
  const label = (type ??
    fileTypeLabel(mimeType ?? null, fileName)) as FileTypeKey;
  const Icon = FILE_TYPE_ICONS[label] ?? DocumentBlank;
  return (
    <span
      className={`file-type-icon file-type-icon-${fileTypeKind(label)}`}
      title={label}
      aria-label={label}
    >
      <Icon size={16} />
    </span>
  );
}
